<ng-container *ngIf="isSuccess; else defaultSnack">
  <div class="snackbar-success-bar">
    <span class="snackbar-info-icon" aria-hidden="true">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="9" stroke="white" stroke-width="1.5" />
        <path
          d="M10 9V14"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <circle cx="10" cy="6.25" r="0.9" fill="white" />
      </svg>
    </span>
    <span class="snackbar-message">{{ data.message }}</span>
    <button
      type="button"
      class="snackbar-close-btn"
      (click)="dismiss()"
      aria-label="Close"
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
          d="M1 1L13 13M13 1L1 13"
          stroke="white"
          stroke-width="1.75"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>
</ng-container>

<ng-template #defaultSnack>
  <span class="example-pizza-party">{{ data.message }}</span>
</ng-template>
